const State = {
  ecGoodsList: [],
  ecReceiveorderList: [],
  nextengineCooperateConfigData: [],
  maxSortNumber: 0
}

export default State
